export const START_SOCKET_CONNECTION = '[App] START_SOCKET_CONNECTION';
export const START_SOCKET_CONNECTION_SUCCESS = '[App] START_SOCKET_CONNECTION_SUCCESS';
export const START_SOCKET_CONNECTION_FAIL = '[App] START_SOCKET_CONNECTION_FAIL';

export const STOP_SOCKET_CONNECTION = '[App] STOP_SOCKET_CONNECTION';
export const STOP_SOCKET_CONNECTION_SUCCESS = '[App] STOP_SOCKET_CONNECTION_SUCCESS';
export const STOP_SOCKET_CONNECTION_FAIL = '[App] STOP_SOCKET_CONNECTION_FAIL';
